import Logs from "../";

const routes = [
    { name: "LogsList", path: "/logs", component: Logs.LogsList, meta: { title: "System Logs - Home" } },
    { name: "Log Detail", path: "/logs/detailsview/:username", component: Logs.LogDetailsViewPage, meta: { title: "System Logs - Detail" } },
];

export default routes;
